import React, { useState, useEffect, useMemo } from "react";
import { Button, Box, Snackbar, Alert } from "@mui/material";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import { TabPanel } from "@mui/lab";
import TabContext from "@mui/lab/TabContext";
import { styled } from "@mui/material/styles";
import { Spinner } from "react-bootstrap";
import { baseUrl } from "../../../../../../network/constants/constants";
import { getConfig } from "../../../../../../network/auth";
import axios from "../../../../../../network/api";
import ServiceEditResponded from "./components/tables/serviceEditResponded";
import ServiceEditPending from "./components/tables/serviceEditPending";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewPageService from "./components/popup/viewPageService";
import SearchField from "../../../../../customComponent/searchField/searchField";

const ServiceEditRequest = () => {
  const [tabValue, setTabValue] = useState("1");
  const [loading, setLoading] = useState(false);
  const [newServiceRequests, setNewServiceRequests] = useState([]);
  const [respondedRequests, setRespondedRequests] = useState([]);
  const [openView, setOpenView] = useState(false);

  const [currentRequest, setCurrentRequest] = useState([]);
  const [newRequest, setNewRequest] = useState([]);
  const [status, setStatus] = useState("");

  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const [currentId, setCurrentId] = useState("");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const handleViewData = (id) => {
    setCurrentId(id);
    setOpenView(true);
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/service-edit-request-by-id/${id}/`, config)
      .then((response) => {
        const data = response.data;

        const currReq = {
          serviceName: data?.current_service_name,
          categoryName: data?.current_category_name,
          description: data?.current_description,
          terms_and_condition: data?.current_terms_and_condition,
          thumb: data?.current_thumb,
          openTime: data?.current_open_time,
          closeTime: data?.current_close_time,
        };

        const newReq = {
          serviceName: data?.new_service_name,
          categoryName: data?.new_category,
          description: data?.new_description,
          terms_and_condition: data?.new_terms_and_condition,
          thumb: data?.new_thumb,
          openTime: data?.new_open_time,
          closeTime: data?.new_close_time,
        };

        const status = data?.status;
        setCurrentRequest(currReq);
        setNewRequest(newReq);
        setStatus(status);

        setLoading(false);
      })
      .catch((error) => {
        console.error("Category Edit request Error:", error);
        setLoading(false);
      });
  };

  const handleCloseView = () => {
    setOpenView(false);
  };

  const fetchServiceEditRequest = () => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/service-edit-requests/`, config)
      .then((response) => {
        const catEditArray = response.data.results;
        const pendingArray = catEditArray.filter(
          (item) => item.status === "Pending"
        );
        const nonPendingArray = catEditArray.filter(
          (item) => item.status !== "Pending"
        );

        setNewServiceRequests(pendingArray);
        setRespondedRequests(nonPendingArray);
        setLoading(false);
      })
      .catch((error) => {
        console.error("service Edit request Error:", error);
        setLoading(false);
      });
  };

  const filteredCategorynew = newServiceRequests.filter(
    (service) =>
      service.current_business_title
        .toLowerCase()
        .includes(searchValue.toLowerCase()) ||
      service.status.toLowerCase().includes(searchValue.toLowerCase())
  );

  const displaynewRequest = searchValue
    ? filteredCategorynew
    : newServiceRequests;
    const newRequestIndex = displaynewRequest.map((edit, index) => ({
      ...edit,
      displayIndex: index + 1,
    }));

  const filteredCategoryResponded = respondedRequests.filter(
    (service) =>
      service.current_business_title
        .toLowerCase()
        .includes(searchValue.toLowerCase()) ||
      service.status.toLowerCase().includes(searchValue.toLowerCase())
  );

  const displayRespondedRequest = searchValue
    ? filteredCategoryResponded
    : respondedRequests;
    const respondedIndex = displayRespondedRequest.map((edit, index) => ({
      ...edit,
      displayIndex: index + 1,
    }));
  useEffect(() => {
    fetchServiceEditRequest();
  }, []);

  const handleAdminResponse = (id, action) => {
    setLoading(true);

    const payload = {
      status: action === "accept" ? "Accepted" : "Rejected",
    };

    axios
      .patch(
        `${baseUrl}superadmin/service-edit-request-update/${id}/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.headers.Authorization,
          },
        }
      )
      .then((response) => {
        fetchServiceEditRequest();
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      })
      .catch((error) => {
        console.error("Error updating request status:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const StyledTab = styled(Tab)({
    "&.Mui-selected": {
      color: "#ff4d4d",
    },
  });

  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "Edit Request Id", width: 120 },
    {
      field: "current_business_title",
      headerName: "Business Name",
      width: 200,
    },
    { field: "status", headerName: "Status", width: 200 },
    {
      field: "actions",
      headerName: "View Details",
      width: 200,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="success"
          style={{ marginRight: "5px" }}
          onClick={() => {
            handleViewData(params.row.id);
          }}
        >
          <VisibilityIcon />
        </Button>
      ),
    },
  ];

  const respondedColumns = columns.filter(
    (column) => column.field !== "acceptReject"
  );

  return (
    <div className="mt-4">
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <TabContext value={tabValue}>
            <Box
              sx={{
                flexGrow: 1,
                maxWidth: { xs: 650, sm: 1500 },
                bgcolor: "background.paper",
              }}
            >
              <TabList
                aria-label="lab API tabs example"
                onChange={handleTabChange}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#ff4d4d",
                  },
                }}
              >
                <StyledTab
                  label="New requests"
                  sx={{ textTransform: "none" }}
                  value="1"
                />
                <StyledTab
                  label="Responded requests"
                  sx={{ textTransform: "none" }}
                  value="2"
                />
              </TabList>
              <TabPanel value="1">
                <SearchField
                  value={searchValue}
                  handleSearchChange={handleSearchChange}
                />
                <ServiceEditPending
                  newServiceRequests={newRequestIndex}
                  requestColumns={columns}
                />
              </TabPanel>
              <TabPanel value="2">
                <SearchField
                  value={searchValue}
                  handleSearchChange={handleSearchChange}
                />
                <ServiceEditResponded
                  respondedRequests={respondedIndex}
                  respondedColumns={respondedColumns}
                />
              </TabPanel>
            </Box>
          </TabContext>
          <ViewPageService
            open={openView}
            onClose={handleCloseView}
            currentRequest={currentRequest}
            newRequest={newRequest}
            status={status}
            handleAdminResponse={handleAdminResponse}
            currentId={currentId}
          />
        </>
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ServiceEditRequest;
